"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiButtonGroup = getMuiButtonGroup;
function getMuiButtonGroup(palette) {
  return {
    defaultProps: {
      // @ts-ignore missing in defaultProps type
      'data-testid': 'required',
      disableElevation: true,
      disableFocusRipple: false,
      disableRipple: true
    },
    styleOverrides: {
      root: {
        '.MuiButton-root': {
          '&.Mui-disabled': {
            '&:not(:last-of-type)': {
              borderColor: palette.grey[50],
              borderRight: 'none'
            },
            '.MuiButton-startIcon': {
              '.MuiSvgIcon-root': {
                color: palette.grey[300]
              }
            },
            backgroundColor: palette.common.white,
            borderColor: palette.grey[50],
            color: palette.grey[300]
          },
          '&:active': {
            '.MuiButton-startIcon': {
              '.MuiSvgIcon-root': {
                color: palette.grey[600]
              }
            },
            '.MuiSvgIcon-root': {
              color: palette.grey[600]
            },
            backgroundColor: palette.grey[50],
            borderColor: palette.grey[300],
            fontWeight: 400
          },
          '&:focus': {
            '.MuiButton-startIcon': {
              '.MuiSvgIcon-root': {
                color: palette.grey[800]
              }
            },
            '.MuiSvgIcon-root': {
              color: palette.grey[800]
            },
            backgroundColor: "".concat(palette.grey[200], " !important"),
            fontWeight: 600,
            outline: 'none'
          },
          '&:has(.MuiButton-startIcon)': {
            maxWidth: '240px',
            minWidth: '80px'
          },
          '&:has(.MuiSvgIcon-root):not(:has(.MuiButton-startIcon))': {
            padding: '8px'
          },
          '&:hover': {
            backgroundColor: palette.grey[50],
            borderColor: palette.grey[300]
          },
          '&:not(:last-of-type)': {
            borderColor: palette.grey[300],
            borderRight: 'none'
          },
          '.MuiButton-startIcon': {
            '.MuiSvgIcon-root': {
              color: palette.grey[600],
              height: '18px',
              width: '18px'
            }
          },
          '.MuiSvgIcon-root': {
            '&:hover ~ &': {
              padding: '8px 12px'
            },
            color: palette.grey[600],
            height: '18px',
            width: '18px'
          },
          backgroundColor: palette.common.white,
          border: "1px solid ".concat(palette.grey[300]),
          borderColor: palette.grey[300],
          borderRadius: '4px',
          color: palette.grey[800],
          fontSize: '14px',
          fontWeight: 400,
          height: '32px',
          lineHeight: '22px',
          padding: '8px 12px',
          textTransform: 'none'
        }
      }
    }
  };
}